import { isMarketOpen } from '../Utils/marketHours';

// One place every data widget asks "what should I show right now?"
//   status: 'loading' | 'live' | 'stale' | 'closed' | 'empty' | 'error'
//   asOf:   ms timestamp of the data shown (for the "as of HH:MM" marker), or null
//
// `stale` and `closed` are deliberately separate. Data can be old while the
// market is open -- a restored cache at first paint, or any feed gap over
// staleMs -- and reporting that as "market closed" states something false about
// the exchange. Only the clock decides `closed`.
//
// No timer subscription: callers already re-render on data ticks so the label
// refreshes on the next natural render without a second subscription.
export function useDataState({ hasData, lastUpdated, staleMs = 90_000, error = null }) {
  const marketOpen = isMarketOpen();
  if (!hasData && error) {
    return { status: 'error', asOf: null, marketOpen, error };
  }
  if (!hasData) return { status: marketOpen ? 'loading' : 'empty', asOf: null, marketOpen };
  if (!marketOpen) return { status: 'closed', asOf: lastUpdated, marketOpen };
  const stale = Date.now() - lastUpdated > staleMs;
  return { status: stale ? 'stale' : 'live', asOf: lastUpdated, marketOpen };
}
